import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { showSnackBar } from '../../../components/Snackbar/Snackbar'
import { getContactById, setFinancingMark } from '../../../features/customer/customerSlice'

// WS 2311820. Program Plan step: the rep turns "Financing" on or off. Saved straight away, apart
// from the plan; unticked by default. Needs a saved client.
const FinancingMarkCheckbox = ({ userId }) => {
  const dispatch = useDispatch()
  const [state, setState] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!userId) return
    let live = true
    dispatch(getContactById(userId)).unwrap()
      .then((payload) => { if (live) setState((payload?.data ?? payload)?.financingState || null) })
      .catch(() => {})
    return () => { live = false }
  }, [userId, dispatch])

  if (!userId || !state || state.state === 'paid') return null

  const handleChange = async (event) => {
    const financed = event.target.checked
    setSaving(true)
    try {
      const payload = await dispatch(setFinancingMark({ userId, financed })).unwrap()
      setState((payload?.data ?? payload) || { ...state, financed })
    } catch (error) {
      showSnackBar('error', typeof error === 'string' ? error : 'Could not save')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="mt-4">
      <label className="flex items-center gap-2 text-sm text-text-primary cursor-pointer">
        <input type="checkbox" checked={!!state.financed} disabled={saving} onChange={handleChange} />
        Client is financing the fee (a lender pays)
      </label>
      {state.chargeable > 0 && (
        <p className="text-xs text-warning-main mt-1 ml-6">
          ⚠ {state.chargeable} card/bank payments will be paused while this is on.
        </p>
      )}
    </div>
  )
}

export default FinancingMarkCheckbox
